//#region Libraries
import { useNavigate } from "react-router-dom";
//#endregion
//#region Styles
import {
	TDef,
	DaysCell,
	LocationCell,
	TimeCell,
	ActionsCell,
	LinkAction,
	DeleteButton,
} from "components/CustomTableList/components/TableListItem/ListItem/styles";
import MiniCaption from "components/MiniCaption/MiniCaption";
import { NameCell, TeacherNameCell, StateCell, Container } from "./styles";
import { ButtonLink, Column, LinkA } from "components/styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import ListItemPendingCaption from "components/CustomTableList/components/TableListItem/ListItemPendingCaption/ListItemPendingCaption";
//#endregion
//#region Services
import { acadReinforcementSessionStorage } from "services/storage/acadReinforcement";
//#endregion
//#region Icons
import TrashIcon from "icons/TrashIcon";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import { abreviationToCompleteDayMonth } from "components/CustomDatePicker/utils/helpers";
import {
	ACAD_REINFORCE_STATE_UNPROCESSED_TAB,
	ACAD_REINFORCE_STATE_UNPROCESSED_TAB_BY_TEXT,
} from "../../utils/constants";
//#endregion

const NoCompletedText = () => {
	return <h4 data-role="no-data">Por completar</h4>;
};
const ListItem = ({
	id, title, standOut,
	date, time, tutor,
	location, creationOrUpdatedDate,
	userRole, currentTabIdx, isTutorUser,
	today, isPending, enrolled,
	dateTime, state,
	isMassive, canTakeAttendance,
	tabData, inSyncOfAcadReinforceUnprocessed,
	openDialogDeleteAcadReinforce,
	openDialogUpdateMassiveAndPendingAcadReinforce
}) => {
	const navigate = useNavigate();
	const isGeneral = currentTabIdx === tabData.values.GENERAL,
		isPast = currentTabIdx === tabData.values.PAST,
		isCancelled = currentTabIdx === tabData.values.CANCELED,
		isDraft = currentTabIdx === tabData.values?.DRAFT,
		isUnprocessed = currentTabIdx === tabData.values?.UNPROCESSED;
	//#region Functions
	const renderContentLocationCell = () => {
		if (!location) return <NoCompletedText />;
		const { zoom, place } = location;
		if (place)
			return (
				<>
					<h4 title={place.campus}>{place.campus}</h4>
					<h5 title={place.address}>{place.address}</h5>
				</>
			);
		const { name, link } = zoom;
		return (
			<>
				<h4>{name}</h4>
				{!link ? (
					<h5>-</h5>
				) : link.startsWith("https://") ? (
					<LinkA
						href={link}
						target="_blank"
						title={link}
					>
						{link}
					</LinkA>
				) : (
					<h5 title={link}>{link}</h5>
				)}
			</>
		);
	};
	const renderEnrolled = () => {
		const [quantityEnrolled, vacancies] = enrolled
			.split("de")
			.map(item => item.trim());
		return (
			<span data-role="enrolled">
				<strong>{quantityEnrolled}</strong> de {vacancies}
			</span>
		);
	};
	const toAttendance = () => {
		if (!canTakeAttendance) return;
		//#region Fechas
		let dateSplit = date.split(", ").pop();
		//#endregion
		const { zoom, place } = location;
		acadReinforcementSessionStorage.acadReinforceDataToAttendance.set({
			id,
			title,
			date: abreviationToCompleteDayMonth(dateSplit),
			time,
			dateTime,
			isPresential: place ? true : zoom ? false : false,
		});
		navigate(ABSOLUTE_PATHS.ATTENDANCE_ACAD_REINFORCE);
	};
	const canUpdate = () => {
		return !isPast && !isCancelled && !inSyncOfAcadReinforceUnprocessed;
	};
	const getIsDisabledUpdateWhenIsMassivePendingAcadReinforce = () => {
		return (
			inSyncOfAcadReinforceUnprocessed ||
			isPast ||
			(state === ACAD_REINFORCE_STATE_UNPROCESSED_TAB.PENDING &&
				location.zoom) ||
			state === ACAD_REINFORCE_STATE_UNPROCESSED_TAB.UPDATED
		);
	};
	const toUpdate = () => {
		if (!canUpdate()) return;
		acadReinforcementSessionStorage.acadReinforceId.set(id);
		acadReinforcementSessionStorage.isAcadReinforceDraft.set(isDraft);
	};
	const renderUpdateButton = () => {
		if (
			[
				ACAD_REINFORCE_STATE_UNPROCESSED_TAB.PENDING,
				ACAD_REINFORCE_STATE_UNPROCESSED_TAB.UPDATED,
			].includes(state)
		)
			return (
				<ButtonLink
					className={
						getIsDisabledUpdateWhenIsMassivePendingAcadReinforce()
							? "disabled"
							: null
					}
					margin="0"
					onClick={() =>
						openDialogUpdateMassiveAndPendingAcadReinforce(id)
					}
				>
					Editar
				</ButtonLink>
			);
		return (
			<LinkAction
				className={!canUpdate() && "disabled"}
				to={ABSOLUTE_PATHS.UPDATE_ACAD_REINFORCE_MANUAL_LOADING}
				onClick={toUpdate}
			>
				Editar
			</LinkAction>
		);
	};
	const canDeleteAcadReinforce = () => {
		const isDeleteableState =
			isUnprocessed ||
			[tabData.values.GENERAL, tabData.values.DRAFT].includes(
				currentTabIdx
			);

		if (!isDeleteableState) return false;

		if (inSyncOfAcadReinforceUnprocessed) return false;

		return true;
	};
	const getClassNameNameCell = () => {
		const classList = ["stand-out", "ellipsis"];
		classList.push(standOut ? "yes" : "no");
		return classList.join(" ");
	};
	//#endregion
	return (
		<Container className={isPast ? "is-past" : ""}>
			<TDef>
				<NameCell
					className={getClassNameNameCell()}
					justify={isDraft && "flex-start"}
				>
					<h3 title={title}>{title}</h3>
					{!isDraft && (
						<div>
							{today && <MiniCaption text="Hoy" />}
							{isMassive && <MiniCaption text="Masiva" />}
							{renderEnrolled()}
							{!isTutorUser && (
								<span
									data-role="created-date"
									title={creationOrUpdatedDate}
								>
									{creationOrUpdatedDate}
								</span>
							)}
						</div>
					)}
				</NameCell>
			</TDef>
			<TDef>
				<DaysCell>
					{date ? <h5>{date}</h5> : <NoCompletedText />}
				</DaysCell>
			</TDef>
			<TDef>
				<TimeCell>
					{time ? <h5>{time}</h5> : <NoCompletedText />}
				</TimeCell>
			</TDef>
			{!isTutorUser && (
				<TDef>
					<TeacherNameCell>
						{tutor ? (
							<h5 title={tutor}>{tutor}</h5>
						) : (
							<NoCompletedText />
						)}
					</TeacherNameCell>
				</TDef>
			)}
			<TDef>
				<LocationCell>{renderContentLocationCell()}</LocationCell>
			</TDef>
			{isUnprocessed && (
				<TDef>
					<StateCell>
						<h5>
							{ACAD_REINFORCE_STATE_UNPROCESSED_TAB_BY_TEXT[state] || "-"}
						</h5>
					</StateCell>
				</TDef>
			)}
			<TDef>
				<ActionsCell
					className="actions-cell"
					minWidth={!isTutorUser ? "200px" : "230px"}
				>
					{isTutorUser && (
						<LinkAction
							to={ABSOLUTE_PATHS.DETAIL_ACAD_REINFORCE}
							minwidth="100px"
							onClick={() => {
								acadReinforcementSessionStorage.acadReinforceId.set(
									id
								);
							}}
						>
							Ver detalle
						</LinkAction>
					)}
					{isTutorUser &&
						[tabData.values.GENERAL, tabData.values.PAST].includes(
							currentTabIdx
						) && (
							<Column
								minWidth="unset"
								align="center"
								gap="3px"
							>
								<CustomButton
									text="Asistencia"
									size="small"
									disabled={!canTakeAttendance}
									onClick={toAttendance}
								/>
								{isGeneral && (
									<ListItemPendingCaption
										isPending={isPending}
									/>
								)}
							</Column>
						)}
					{!isTutorUser && renderUpdateButton()}
					{!isTutorUser && (
						<DeleteButton
							onClick={() =>
								canDeleteAcadReinforce() &&
								openDialogDeleteAcadReinforce(id)
							}
							disabled={!canDeleteAcadReinforce()}
						>
							<TrashIcon />
						</DeleteButton>
					)}
				</ActionsCell>
			</TDef>
		</Container>
	);
};

export default ListItem;
